import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import { Marker } from './Marker';
import { createBaseMapOptions } from './helpers/createMapOptions';
import { styles } from './Map.scss';

const cx = classNames.bind(styles);

export const BaseMap = ({
  apiKey,
  lat,
  lng,
  className,
  children,
  ...props
}) => {
  const classes = cx('c-map', className);

  return (
    <div className={classes} {...props}>
      <GoogleMapReact
        bootstrapURLKeys={{
          key: apiKey,
        }}
        defaultCenter={{
          lat,
          lng,
        }}
        zoom={15}
        options={createBaseMapOptions}>
        <Marker interactive={false} lat={lat} lng={lng} />
      </GoogleMapReact>
      {children}
    </div>
  );
};

BaseMap.propTypes = {
  apiKey: PropTypes.string.isRequired,
  lat: PropTypes.number,
  lng: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.any,
};

BaseMap.defaultProps = {
  className: '',
};
